import React from 'react';
import Pikaday from 'pikaday';
import { string, number, func, bool } from 'prop-types';

class Datepicker extends React.Component {
    // Validate data for props
    static propTypes = {
        datepickerID: string.isRequired,
        placeholderText: string.isRequired,
        maxDate: number.isRequired,
        defaultDate: number,
        handleDate: func.isRequired,
        label: string.isRequired,
        limitedDate: bool.isRequired
    };

    static defaultProps = { defaultDate: 0 }

    componentDidMount() {
        const self = this;
        const maxDate = this.props.limitedDate ? new Date(this.props.maxDate) : 0;
        const handleFunc = this.props.handleDate;
        const theDate = this.props.defaultDate;
        this.pikaObject = new Pikaday({
            field: self.pikadayNode,
            format: 'DD MMM',
            firstDay: 1,
            maxDate,
            disableWeekends: false,
            onSelect: date => {
                if (theDate !== date.getTime()) {
                    handleFunc(date);
                }
            }
        });

        this.setPikadayInput(this.props);
    }

    shouldComponentUpdate(nextProps) {
        if (Number.isNaN(this.props.defaultDate) && Number.isNaN(nextProps.defaultDate)) {
            return false;
        }

        return (this.props.defaultDate !== nextProps.defaultDate);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultDate !== this.props.defaultDate) {
            this.setPikadayInput(this.props);
        }
    }

    setPikadayInput(theProps) {
        if (theProps.defaultDate) {
            const monthNames = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
            ];
            const dDate = new Date(theProps.defaultDate);
            const subYear = dDate.getFullYear().toString().substr(-2);
            this.pikaObject.setDate(dDate);
            this.pikaObject.gotoDate(dDate);
            this.pikadayNode.value = `${dDate.getDate()} ${monthNames[dDate.getMonth()]} ${subYear}`;
        } else {
            this.pikaObject.setDate(null);
            this.pikaObject.gotoDate(new Date());
            this.pikadayNode.value = '';
        }
    }

    render() {
        return (
            <div className="react-pikaday-wrapper">
                <div className="label-wrapper">
                    <label htmlFor={`field-${this.props.datepickerID}`}>{this.props.label}</label>
                </div>

                <input readOnly={true} ref={pikadayNode => { this.pikadayNode = pikadayNode; }} id={`field-${this.props.datepickerID}`} type="text" className="react-pikaday" placeholder={this.props.placeholderText} />
            </div>
        );
    }
}

export default Datepicker;
